(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3165],{

/***/ 42209:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z"
}), 'AcUnit');

exports.Z = _default;

/***/ }),

/***/ 27036:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');

exports.Z = _default;

/***/ }),

/***/ 63343:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');

exports.Z = _default;

/***/ }),

/***/ 50594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

exports.Z = _default;

/***/ }),

/***/ 63441:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z"
}), 'Download');

exports.Z = _default;

/***/ }),

/***/ 23513:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75-.9.92c-.5.51-.86.97-1.04 1.69-.08.32-.13.68-.13 1.14h-2v-.5c0-.46.08-.9.22-1.31.2-.58.53-1.1.95-1.52l1.24-1.26c.46-.44.68-1.1.55-1.8-.13-.72-.69-1.33-1.39-1.53-1.11-.31-2.14.32-2.47 1.27-.12.37-.43.65-.82.65h-.3C8.4 9 8 8.44 8.16 7.88c.43-1.47 1.68-2.59 3.23-2.83 1.52-.24 2.97.55 3.87 1.8 1.18 1.63.83 3.38-.19 4.4z"
}), 'HelpRounded');

exports.Z = _default;

/***/ }),

/***/ 51636:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M7.5 4C5.57 4 4 5.57 4 7.5S5.57 11 7.5 11 11 9.43 11 7.5 9.43 4 7.5 4zm0 5C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm9 4c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5.41 20 4 18.59 18.59 4 20 5.41 5.41 20z"
}), 'PercentOutlined');

exports.Z = _default;

/***/ }),

/***/ 91339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
  cx: "12",
  cy: "19",
  r: "2"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M10 3h4v12h-4z"
}, "1")], 'PriorityHigh');

exports.Z = _default;

/***/ }),

/***/ 17437:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M9.68 13.69 12 11.93l2.31 1.76-.88-2.85L15.75 9h-2.84L12 6.19 11.09 9H8.25l2.31 1.84-.88 2.85zM20 10c0-4.42-3.58-8-8-8s-8 3.58-8 8c0 2.03.76 3.87 2 5.28V23l6-2 6 2v-7.72c1.24-1.41 2-3.25 2-5.28zm-8-6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6z"
}), 'WorkspacePremium');

exports.Z = _default;

/***/ }),

/***/ 30120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61354);
/* harmony import */ var _className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18356);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76281);




const defaultTheme = (0,_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
const Box = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  defaultTheme,
  defaultClassName: 'MuiBox-root',
  generateClassName: _className__WEBPACK_IMPORTED_MODULE_2__/* ["default"].generate */ .Z.generate
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Box);

/***/ }),

/***/ 75741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getDividerUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45154);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22104);


function getDividerUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiDivider', slot);
}
const dividerClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiDivider', ['root', 'absolute', 'fullWidth', 'inset', 'middle', 'flexItem', 'light', 'vertical', 'withChildren', 'withChildrenVertical', 'textAlignRight', 'textAlignLeft', 'wrapper', 'wrapperVertical']);
/* harmony default export */ __webpack_exports__["Z"] = (dividerClasses);

/***/ }),

/***/ 8164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getListItemIconUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45154);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22104);


function getListItemIconUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiListItemIcon', slot);
}
const listItemIconClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiListItemIcon', ['root', 'alignItemsFlexStart']);
/* harmony default export */ __webpack_exports__["Z"] = (listItemIconClasses);

/***/ }),

/***/ 97484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getListItemTextUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45154);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22104);


function getListItemTextUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiListItemText', slot);
}
const listItemTextClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiListItemText', ['root', 'multiline', 'dense', 'inset', 'primary', 'secondary']);
/* harmony default export */ __webpack_exports__["Z"] = (listItemTextClasses);

/***/ }),

/***/ 31538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MenuItem_MenuItem; }
});

// UNUSED EXPORTS: overridesResolver

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1048);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(93680);
// EXTERNAL MODULE: ./node_modules/@mui/base/node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(93427);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(78884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/List/ListContext.js
var ListContext = __webpack_require__(57742);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ButtonBase/ButtonBase.js + 8 modules
var ButtonBase = __webpack_require__(84861);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(63289);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useForkRef.js + 1 modules
var useForkRef = __webpack_require__(71315);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/dividerClasses.js
var dividerClasses = __webpack_require__(75741);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemIcon/listItemIconClasses.js
var listItemIconClasses = __webpack_require__(8164);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemText/listItemTextClasses.js
var listItemTextClasses = __webpack_require__(97484);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(45154);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(22104);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/MenuItem/menuItemClasses.js


function getMenuItemUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiMenuItem', slot);
}
const menuItemClasses = (0,generateUtilityClasses/* default */.Z)('MuiMenuItem', ['root', 'focusVisible', 'dense', 'disabled', 'divider', 'gutters', 'selected']);
/* harmony default export */ var MenuItem_menuItemClasses = (menuItemClasses);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/MenuItem/MenuItem.js


const _excluded = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"];
















const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters];
};

const useUtilityClasses = ownerState => {
  const {
    disabled,
    dense,
    divider,
    disableGutters,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', disabled && 'disabled', !disableGutters && 'gutters', divider && 'divider', selected && 'selected']
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, getMenuItemUtilityClass, classes);
  return (0,esm_extends/* default */.Z)({}, classes, composedClasses);
};

const MenuItemRoot = (0,styled/* default */.ZP)(ButtonBase/* default */.Z, {
  shouldForwardProp: prop => (0,styled/* rootShouldForwardProp */.FO)(prop) || prop === 'classes',
  name: 'MuiMenuItem',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({}, theme.typography.body1, {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: 'border-box',
  whiteSpace: 'nowrap'
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, ownerState.divider && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
  backgroundClip: 'padding-box'
}, {
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: (theme.vars || theme).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${MenuItem_menuItemClasses.selected}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${MenuItem_menuItemClasses.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${MenuItem_menuItemClasses.selected}:hover`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  },
  [`&.${MenuItem_menuItemClasses.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`&.${MenuItem_menuItemClasses.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  },
  [`& + .${dividerClasses/* default.root */.Z.root}`]: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  [`& + .${dividerClasses/* default.inset */.Z.inset}`]: {
    marginLeft: 52
  },
  [`& .${listItemTextClasses/* default.root */.Z.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${listItemTextClasses/* default.inset */.Z.inset}`]: {
    paddingLeft: 36
  },
  [`& .${listItemIconClasses/* default.root */.Z.root}`]: {
    minWidth: 36
  }
}, !ownerState.dense && {
  [theme.breakpoints.up('sm')]: {
    minHeight: 'auto'
  }
}, ownerState.dense && (0,esm_extends/* default */.Z)({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, theme.typography.body2, {
  [`& .${listItemIconClasses/* default.root */.Z.root} svg`]: {
    fontSize: '1.25rem'
  }
})));
const MenuItem = /*#__PURE__*/react.forwardRef(function MenuItem(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiMenuItem'
  });

  const {
    autoFocus = false,
    component = 'li',
    dense = false,
    divider = false,
    disableGutters = false,
    focusVisibleClassName,
    role = 'menuitem',
    tabIndex: tabIndexProp,
    className
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const context = react.useContext(ListContext/* default */.Z);
  const childContext = react.useMemo(() => ({
    dense: dense || context.dense || false,
    disableGutters
  }), [context.dense, dense, disableGutters]);
  const menuItemRef = react.useRef(null);
  (0,useEnhancedEffect/* default */.Z)(() => {
    if (autoFocus) {
      if (menuItemRef.current) {
        menuItemRef.current.focus();
      } else if (false) {}
    }
  }, [autoFocus]);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    dense: childContext.dense,
    divider,
    disableGutters
  });

  const classes = useUtilityClasses(props);
  const handleRef = (0,useForkRef/* default */.Z)(menuItemRef, ref);
  let tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ListContext/* default.Provider */.Z.Provider, {
    value: childContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItemRoot, (0,esm_extends/* default */.Z)({
      ref: handleRef,
      role: role,
      tabIndex: tabIndex,
      component: component,
      focusVisibleClassName: (0,clsx_m/* default */.Z)(classes.focusVisible, focusVisibleClassName),
      className: (0,clsx_m/* default */.Z)(classes.root, className)
    }, other, {
      ownerState: ownerState,
      classes: classes
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var MenuItem_MenuItem = (MenuItem);

/***/ }),

/***/ 98529:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/producto/[prodSlug]",
      function () {
        return __webpack_require__(89438);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ ShowProduct; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(66252);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(68921);
;// CONCATENATED MODULE: ./src/queries/product/queries/getProduct.tsx
/*
 * File: getProduct.tsx
 * Project: meki
 * File Created: Monday, 28th September 2020 11:38:59 am
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Wednesday, 15th December 2021 5:23:37 pm
 * Modified By: Luis Aparicio (luis@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ",
        '($params: ProductParams!) {\n    product(params: $params ){\n      id\n      uuid\n      slug\n      name\n      description\n      price\n      discount {\n          price\n          type\n          stockRestriction\n          dateRestriction\n          listPrice\n        }\n      concentration\n      prescriptionType\n      unit\n      quantity\n      package\n      composition\n      posology\n      display\n      contraindications\n      indications\n      containerQuantity\n      container\n      metadata {\n        ispRegister\n        refrigerated\n      }\n      relatedProducts(relation: "bioequivalente") {\n        id\n        uuid\n        slug\n        name\n        activePrinciple\n        description\n        price\n        discount {\n          price\n          type\n          stockRestriction\n          dateRestriction\n          listPrice\n        }\n        concentration\n        availability {\n          status\n          stock\n          statusWithoutStock\n          discountStock\n        }\n        format\n        laboratory\n        imagesUrl\n        prescriptionType\n        unit\n        quantity\n        isBioequivalent\n        isCheapestActivePrinciple\n      }\n      availability {\n        status\n        statusWithoutStock\n        stock\n        discountStock\n      }\n      imagesUrl\n      format\n      isBioequivalent\n      activePrinciple\n      laboratory\n      externalPrices {\n        amount\n        saleAmount\n        seller\n        lastUpdate\n      }\n      isCenabast\n      isMedicine\n      thumbnailUrl\n      isCheapestActivePrinciple\n    }\n  }\n  '
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getProduct = function(name) {
    return (0,lib/* gql */.Ps)(_templateObject(), name);
};

// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
// EXTERNAL MODULE: ./src/components/seo.tsx
var seo = __webpack_require__(39425);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(71641);
// EXTERNAL MODULE: ./src/screens/product/utils/extractExtraInfo.tsx
var extractExtraInfo = __webpack_require__(73724);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocalShippingOutlined.js
var LocalShippingOutlined = __webpack_require__(41865);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PercentOutlined.js
var PercentOutlined = __webpack_require__(51636);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Store.js
var Store = __webpack_require__(39595);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/WarningAmber.js
var WarningAmber = __webpack_require__(59748);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AccessTime.js
var AccessTime = __webpack_require__(90244);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(63761);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/screens/product/components/InfoTag.styles.ts


var InfoTagContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    alignItems: "center",
    gap: "8px"
});
var IconContainer = (0,styled/* default */.Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "backgroundColor" && prop !== "iconColor";
    }
})(function(param) {
    var backgroundColor = param.backgroundColor, iconColor = param.iconColor;
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "100%",
        width: "26px",
        height: "26px",
        backgroundColor: backgroundColor,
        svg: {
            color: iconColor,
            fontSize: "19px"
        }
    };
});
var ContentContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start"
    };
});
var InfoTagTitle = (0,styled/* default */.Z)(Typography/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "color";
    }
})(function(param) {
    var color = param.color;
    return {
        color: color,
        fontSize: "14px",
        fontWeight: 300
    };
});
var InfoTagContent = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        fontSize: "14px",
        fontWeight: 400,
        color: theme.palette.text.secondary
    };
});
var InfoTag_styles_Strong = (0,styled/* default */.Z)("span")({
    fontWeight: 600
});

;// CONCATENATED MODULE: ./src/screens/product/components/InfoTag.tsx










var InfoTag = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoTagContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                iconColor: props.iconColor,
                backgroundColor: props.backgroundColor,
                children: props.icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTagTitle, {
                        color: props.color,
                        children: props.title
                    }),
                    props.detail && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTagContent, {
                        children: props.detail
                    })
                ]
            })
        ]
    });
};
var extractDeliveryDate = function(product) {
    var ref;
    var availability = (ref = product.availability) === null || ref === void 0 ? void 0 : ref.status;
    if (availability === "AVAILABLE_24_HRS") {
        var next = (0,utils/* next24hrsDay */.sj)();
        return (0,utils/* extractMiddleDate */.re)(next);
    }
    if ([
        "REPRESENTATION",
        "AVAILABLE"
    ].includes(availability)) {
        var next1 = (0,utils/* addBusinessDays */.lR)(new Date(Date.now()), 3);
        return (0,utils/* extractMiddleDate */.re)(next1);
    }
    return null;
};
var extractNearDay = function(product) {
    var ref;
    var availability = (ref = product.availability) === null || ref === void 0 ? void 0 : ref.status;
    if (availability === "AVAILABLE_24_HRS") {
        var next = (0,utils/* next24hrsDay */.sj)();
        if (next.toDateString() === new Date().toDateString()) return "hoy";
        if (next.toDateString() === (0,addDays/* default */.Z)(new Date(), 1).toDateString()) return "ma\xf1ana";
        if (next.toDateString() === (0,utils/* addBusinessDays */.lR)(new Date(), 1).toDateString()) return "el " + (0,utils/* getWeekdayName */.ng)(next);
    }
    if ([
        "AVAILABLE",
        "REPRESENTATION"
    ].includes(availability)) {
        var next1 = (0,utils/* addBusinessDays */.lR)(new Date(Date.now()), 3);
        return (0,utils/* getWeekdayName */.ng)(next1);
    }
    return null;
};
var InfoTagDeliveryDate = function(props) {
    var ref;
    var deliveryDate = extractDeliveryDate(props.product);
    var nearDate = extractNearDay(props.product);
    var express = ((ref = props.product.availability) === null || ref === void 0 ? void 0 : ref.status) === "AVAILABLE_24_HRS";
    var title = express ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        children: [
            "Recibe ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag_styles_Strong, {
                children: nearDate
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        children: [
            "Recibe el ",
            nearDate
        ]
    });
    var detail = props.maxQuantity ? "".concat(props.maxQuantity, " un. con entrega ").concat(deliveryDate) : deliveryDate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalShippingOutlined/* default */.Z, {}),
        backgroundColor: express ? "#00a650" : "#757475",
        color: express ? "#00a650" : "#414046",
        iconColor: "white",
        title: title,
        detail: detail
    });
};
var InfoTagCheapest = function(props) {
    return /*#__PURE__*/ _jsx(InfoTag, {
        icon: /*#__PURE__*/ _jsx(AttachMoneyIcon, {}),
        backgroundColor: "#5D5FEF",
        color: "#5D5FEF",
        iconColor: "white",
        title: /*#__PURE__*/ _jsxs("span", {
            children: [
                "Comprimido ",
                /*#__PURE__*/ _jsx(Strong, {
                    children: "m\xe1s econ\xf3mico"
                })
            ]
        }),
        detail: "de ".concat(props.activePrinciple)
    });
};
var InfoTagOnDemand = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccessTime/* default */.Z, {}),
        backgroundColor: "#fff0d6",
        color: "#603e11",
        iconColor: "#ffa200",
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "Producto ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag_styles_Strong, {
                    children: "a pedido"
                })
            ]
        }),
        detail: "Entrega estimada de 3 semanas"
    });
};
var InfoTagSoldOut = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningAmber/* default */.Z, {}),
        backgroundColor: "#ffe2e2",
        color: "#602d11",
        iconColor: "#ff0000",
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "Producto ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag_styles_Strong, {
                    children: "agotado"
                })
            ]
        })
    });
};
var InfoTagLocalSell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Store/* default */.Z, {}),
        backgroundColor: "#f2eff5",
        color: "#2d0076",
        iconColor: "#731eff",
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "Solo ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag_styles_Strong, {
                    children: "venta presencial"
                })
            ]
        }),
        detail: "Medicamento con receta cheque"
    });
};
var InfoTagDiscountType = function(props) {
    var type = props.type;
    var title = function(type) {
        if (type == "EXPIRATION") {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "Descuento por ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag_styles_Strong, {
                        children: "vencimiento"
                    })
                ]
            });
        }
    };
    var detail = type === "EXPIRATION" ? "entre 2 y 6 meses" : type === "MEKI" ? "precios bajos para todos, todos los d\xedas" : null;
    var color = "#5D5FEF";
    var backgroundColor = "#5D5FEF";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PercentOutlined/* default */.Z, {}),
        backgroundColor: backgroundColor,
        color: color,
        iconColor: "white",
        title: title(type),
        detail: detail
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/ModalImage.tsx
var ModalImage = __webpack_require__(24714);
;// CONCATENATED MODULE: ./src/screens/product/components/ProductImage.tsx






var ImageContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme, onClick = param.onClick;
    return (0,_define_property/* default */.Z)({
        width: "100%",
        maxWidth: "80%",
        margin: "16px auto",
        minHeight: 150,
        position: "relative",
        cursor: onClick ? "pointer" : "auto"
    }, theme.breakpoints.up(768), {
        flex: "1 0 50%",
        maxWidth: "unset",
        span: {
            maxWidth: "80%",
            margin: "auto !important"
        }
    });
});
var defaultImage = "/assets/images/default.webp";
function ProductImage(param) {
    var product = param.product;
    var ref;
    var ref1 = (0,react.useState)(((ref = product.imagesUrl) === null || ref === void 0 ? void 0 : ref[0]) || defaultImage), imageUrl = ref1[0], setImageUrl = ref1[1];
    var ref2 = (0,react.useState)(false), imageModal = ref2[0], setImageModal = ref2[1];
    (0,react.useEffect)(function syncronizeImageOnChangeUrl() {
        var ref;
        if (product === null || product === void 0 ? void 0 : (ref = product.imagesUrl) === null || ref === void 0 ? void 0 : ref[0]) {
            var ref1;
            setImageUrl(product === null || product === void 0 ? void 0 : (ref1 = product.imagesUrl) === null || ref1 === void 0 ? void 0 : ref1[0]);
        }
    }, [
        product === null || product === void 0 ? void 0 : product.imagesUrl
    ]);
    var handleImageError = (0,react.useCallback)(function() {
        setImageUrl(defaultImage);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                onClick: imageUrl !== defaultImage ? function() {
                    return setImageModal(true);
                } : undefined,
                role: imageUrl !== defaultImage ? "button" : undefined,
                "aria-label": "Abrir imagen de ".concat(product.name),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: imageUrl,
                    layout: "fill",
                    alt: "Foto ".concat(product.name),
                    objectFit: "contain",
                    onError: handleImageError,
                    placeholder: "blur",
                    blurDataURL: "/assets/images/default.webp"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalImage/* ModalImage */.E, {
                imageModal: imageModal,
                setImageModal: setImageModal,
                imageUrl: imageUrl,
                handleImageError: handleImageError,
                productName: product.name,
                isProduct: true
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 4 modules
var useAuth = __webpack_require__(21566);
;// CONCATENATED MODULE: ./src/queries/pillBox/queries/getPillBoxDetail.tsx
/*
 * File: getPillBoxDetail.tsx
 * Project: meki
 * File Created: Tuesday, 25th January 2022 3:29:05 pm
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Tuesday, 26th July 2022 4:06:16 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2022 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function getPillBoxDetail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetPillBoxDetail($params: GetPillBoxDetailParams!) {\n    pillBoxDetail(params: $params) {\n      id\n      lastMovementBalance\n      userStock\n      frequency\n      remainingBalanceDays\n      lastOrderDate\n      speedConsumption\n      consumptionUnit\n      hidden\n      product {\n        id\n        uuid\n        name\n        format\n        slug\n        unit\n        concentration\n        activePrinciple\n        availability {\n          status\n        }\n        laboratory\n        prescriptionType\n        price\n        isMedicine\n        thumbnailUrl\n      }\n    }\n  }\n"
    ]);
    getPillBoxDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getPillBoxDetail = function() {
    return (0,lib/* gql */.Ps)(getPillBoxDetail_templateObject());
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./src/hooks/useAddProduct.tsx
var useAddProduct = __webpack_require__(59509);
// EXTERNAL MODULE: ./src/hooks/useModalRouter.ts
var useModalRouter = __webpack_require__(9006);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(26993);
// EXTERNAL MODULE: ./src/screens/product/hooks/useUpdateQuantity.ts + 1 modules
var useUpdateQuantity = __webpack_require__(10830);
// EXTERNAL MODULE: ./src/hooks/useCartMenu.tsx
var useCartMenu = __webpack_require__(85745);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(1890);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(67836);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
;// CONCATENATED MODULE: ./src/queries/requestedUnavaibleProducts/mutations/createRequestedUnavailebleProducts.tsx
/*
 * File: createRequestedUnavailebleProducts.ts
 * Project: meki
 * File Created: Thursday, 2nd February 2023 5:57:26 pm
 * Author: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Last Modified: Wednesday, 15th February 2023 12:19:28 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2023 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function createRequestedUnavailebleProducts_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateRequestedUnavailableProducts(\n    $params: CreateRequestedProductsParams!\n  ) {\n    createRequestedUnavailableProducts(params: $params) {\n      id\n      notificationEmail\n      quantity\n      productId\n      notified\n      userId\n      dateNotified\n    }\n  }\n"
    ]);
    createRequestedUnavailebleProducts_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CreateRequestedUnavailableProductsMutation = function() {
    return (0,lib/* gql */.Ps)(createRequestedUnavailebleProducts_templateObject());
};

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/hooks/toast.hook.tsx + 4 modules
var toast_hook = __webpack_require__(11263);
// EXTERNAL MODULE: ./src/services/sentry.ts
var sentry = __webpack_require__(52353);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Check.js
var Check = __webpack_require__(27036);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
;// CONCATENATED MODULE: ./src/screens/product/components/LetMeKnowWhenItsAvailableModal.tsx






function LetMeKnowWhenItsAvailableModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 26px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  letter-spacing: 0.15px;\n  color: #414046;\n  padding: 3px 14px 12px 14px;\n"
    ]);
    LetMeKnowWhenItsAvailableModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 21px;\n  letter-spacing: 0.15px;\n  color: #414046;\n  margin: 0px 14px 17px 14px;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px 0px 49px 0px;\n  width: 200px;\n  height: 42px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.15px;\n  text-transform: none;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 30px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px 18px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #00a650;\n  height: 19.2px;\n  width: 19.2px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border: 1.2px solid #00a650;\n  border-radius: 100px;\n  width: 32px;\n  height: 32px;\n  margin: 17px 0px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 26px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  letter-spacing: 0.15px;\n  color: #414046;\n  padding: 0px 14px 12px 14px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 21px;\n  letter-spacing: 0.15px;\n  color: #414046;\n  margin: 0px 14px 30px 14px;\n  text-align: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 13px;\n  top: 16px;\n  color: #414046;\n  width: 14px;\n  height: 14px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 46px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}















var NotificationDialog = (0,styled/* default */.Z)(Dialog/* default */.Z)({
    borderRadius: "10px",
    "& .MuiDialog-paper": {
        borderRadius: "10px",
        minHeight: "328px",
        maxWidth: "438px"
    }
});
var NotificationTitle = (0,styled/* default */.Z)(Typography/* default */.Z)(LetMeKnowWhenItsAvailableModal_templateObject());
var NotificationTextDialogDescription = (0,styled/* default */.Z)(Typography/* default */.Z)(_templateObject1());
var SendButtonContainer = (0,styled/* default */.Z)("div")(_templateObject2());
var SendButton = (0,styled/* default */.Z)(Button/* default */.Z)(_templateObject3());
var TextInput = (0,styled/* default */.Z)(TextField/* default */.Z)(_templateObject4());
var InputDiv = (0,styled/* default */.Z)("div")(_templateObject5());
var CheckIconStyled = (0,styled/* default */.Z)(Check/* default */.Z)(_templateObject6());
var CheckCircleDiv = (0,styled/* default */.Z)("div")(_templateObject7());
var CheckIconDiv = (0,styled/* default */.Z)("div")(_templateObject8());
var NotificationSuccesTitle = (0,styled/* default */.Z)(Typography/* default */.Z)(_templateObject9());
var NotificationSuccesText = (0,styled/* default */.Z)(Typography/* default */.Z)(_templateObject10());
var CloseButton = (0,styled/* default */.Z)(IconButton/* default */.Z)(_templateObject11());
var HeaderDiv = (0,styled/* default */.Z)("div")(_templateObject12());
var TAG = "[PRODUCT_VIEW] ";
var LetMeKnownWhenItsAvailableModal = function(props) {
    var ref, ref1;
    var openDialog = props.openDialog, setClose = props.setClose, product = props.product;
    var track = (0,useSegment/* useSegment */.K)().track;
    var ref2 = (0,index_esm/* useForm */.cI)(), register = ref2.register, handleSubmit = ref2.handleSubmit, getValues = ref2.getValues, errors = ref2.formState.errors, setValue = ref2.setValue;
    var appUser = (0,useAuth/* useAuth */.a)().appUser;
    var showToast = (0,toast_hook/* useToast */.p)().showToast;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CreateRequestedUnavailableProductsMutation()), 2), sendRequest = ref3[0], loading = ref3[1].loading;
    var ref4 = (0,react.useState)(false), requestSend = ref4[0], setRequestSend = ref4[1];
    var onSubmit = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        4
                    ]);
                    void track("request know availability sent", {
                        availability: (ref = product.availability) === null || ref === void 0 ? void 0 : ref.status,
                        brand: product.laboratory,
                        id: product.id,
                        name: product.name
                    });
                    data = getValues();
                    utils/* Console.log */.Mn.log({
                        msg: TAG + "Requesting unavaiable product",
                        productId: product.id,
                        notificationEmail: data.email
                    });
                    return [
                        4,
                        sendRequest({
                            variables: {
                                params: {
                                    productId: product.id,
                                    notificationEmail: data.email,
                                    quantity: 1
                                }
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    setRequestSend(true);
                    return [
                        3,
                        4
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        4,
                        (0,sentry/* getSentry */.$)().then(function(Sentry) {
                            Sentry.captureException(error);
                        })
                    ];
                case 3:
                    _state.sent();
                    showToast({
                        message: "Error al enviar la solicitud",
                        type: "error"
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        getValues,
        sendRequest,
        showToast,
        product.id,
        track,
        product.availability,
        product.name,
        product.laboratory, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationDialog, {
            open: openDialog,
            onClose: function() {
                setClose();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDiv, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                        "aria-label": "close",
                        onClick: function() {
                            setClose();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                    })
                }),
                requestSend ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIconDiv, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleDiv, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIconStyled, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationSuccesTitle, {
                            children: "Recordatorio creado"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationSuccesText, {
                            children: "Te enviaremos un correo cuando el producto est\xe9 disponible."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SendButtonContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SendButton, {
                                variant: "contained",
                                onClick: function() {
                                    void router.push((0,utils/* getRoute */.Bv)("home"));
                                },
                                children: "Ir al inicio"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationTitle, {
                            children: "Crear recordatorio"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationTextDialogDescription, {
                            children: "Completa los datos y te avisaremos cuando el producto vuelva a estar disponible."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputDiv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        variant: "outlined",
                                        size: "small"
                                    }, register("email", {
                                        required: "Necesitamos tu correo electr\xf3nico",
                                        pattern: {
                                            value: /^([a-zA-Z0-9_\-\+\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
                                            message: "Este email est\xe1 incompleto \uD83E\uDD37‍♀"
                                        },
                                        onChange: function(event) {
                                            return setValue("email", event.target.value.toLowerCase().trim());
                                        },
                                        value: (appUser === null || appUser === void 0 ? void 0 : appUser.email) || ""
                                    })), {
                                        label: "Correo electr\xf3nico",
                                        error: Boolean((ref = errors.email) === null || ref === void 0 ? void 0 : ref.message),
                                        helperText: (ref1 = errors.email) === null || ref1 === void 0 ? void 0 : ref1.message
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SendButtonContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SendButton, {
                                        variant: "contained",
                                        type: "submit",
                                        disabled: loading,
                                        children: "Enviar"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(71096);
;// CONCATENATED MODULE: ./src/screens/product/utils/pluralize.ts
function pluralize(word, count, plural) {
    return count > 1 ? "".concat(word).concat(plural) : word;
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Select/Select.js + 4 modules
var Select = __webpack_require__(53442);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(31538);
;// CONCATENATED MODULE: ./src/screens/product/components/ActionContainer.styles.ts


var Container = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return {
        bottom: "0",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "24px"
    };
});
var AddContainer = (0,styled/* default */.Z)("div")({
    width: "100%",
    height: "100%",
    justifyContent: "start",
    alignItems: "center"
});
var AddButton = (0,styled/* default */.Z)(Button/* default */.Z)({
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: "Poppins",
    height: 42,
    width: "100%"
});
var UnitsContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    gap: 4
});
var HeaderModal = (0,styled/* default */.Z)("div")({
    padding: "10px 5px 10px 20px",
    textAlign: "start",
    fontWeight: 500,
    display: "flex",
    fontFamily: "Poppins",
    justifyContent: "space-between",
    fontSize: "14px",
    lineHeight: "19px"
});
var SelectContainer = (0,styled/* default */.Z)(Select/* default */.Z)({
    width: "100%",
    height: 42,
    fontSize: 13,
    fontWeight: 400,
    fontFamily: "Poppins",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#EAEAEA"
    },
    cursor: "pointer"
});
var MenuItemText = (0,styled/* default */.Z)(MenuItem/* default */.Z)({
    fontSize: 13,
    fontWeight: 400,
    fontFamily: "Poppins",
    color: "#747474",
    justifyContent: "center",
    alignItems: "center"
});
var HelperText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "12px",
    fontWeight: 400,
    fontFamily: "Poppins",
    color: "#414046",
    lineHeight: "15px"
});
var QuantityText = (0,styled/* default */.Z)("span")({
    fontSize: 13,
    fontWeight: 700,
    fontFamily: "Poppins"
});
var HelperQuantityText = (0,styled/* default */.Z)("span")({
    fontWeight: 300,
    color: "#747474"
});


;// CONCATENATED MODULE: ./src/screens/product/components/ActionContainer.tsx



function ActionContainer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: white;\n"
    ]);
    ActionContainer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


















var getStockMessage = function(param) {
    var prescriptionType = param.prescriptionType, quantity = param.quantity, maxAmount = param.maxAmount, isMaxAmount = param.isMaxAmount;
    if (prescriptionType === "HELD") {
        if (!quantity) return "";
        return "".concat(quantity, " ").concat(pluralize("unidad", quantity, "es"), " en el carro");
    }
    if (maxAmount > 100) {
        return "";
    }
    if (quantity === 0) {
        return maxAmount !== 6 ? "".concat(maxAmount, " ").concat(pluralize("unidad", maxAmount, "es"), " en stock") : "M\xe1ximo ".concat(maxAmount, " ").concat(pluralize("unidad", maxAmount, "es"));
    }
    if (isMaxAmount) {
        return "Has agregado el m\xe1ximo de unidades posibles al carro";
    }
    return maxAmount !== 6 ? "".concat(quantity, " ").concat(pluralize("unidad", quantity, "es"), " en el carro de ").concat(maxAmount, " en stock") : "".concat(quantity, " ").concat(pluralize("unidad", quantity, "es"), " en el carro, m\xe1ximo ").concat(maxAmount);
};
var CustomMenu = function(param) {
    var isMobile = param.isMobile, height = param.height;
    return {
        anchorReference: isMobile ? "anchorPosition" : "anchorEl",
        anchorPosition: isMobile ? {
            top: height,
            left: 0
        } : undefined,
        transformOrigin: isMobile ? {
            vertical: "bottom",
            horizontal: "center"
        } : {
            vertical: "top",
            horizontal: "center"
        },
        PaperProps: {
            sx: isMobile ? {
                width: "100%",
                bottom: 0,
                borderRadius: "12px 12px 0 0",
                backgroundColor: "white",
                position: "fixed",
                maxWidth: "unset",
                left: "0 !important",
                top: "auto !important"
            } : {
                maxHeight: 300
            }
        },
        disableScrollLock: true,
        disablePortal: true
    };
};
var LoadingButton = (0,styled/* default */.Z)(CircularProgress/* default */.Z)(ActionContainer_templateObject());
var ActionContainer = function(param) {
    var product = param.product, isSelectOpen = param.isSelectOpen, handleSelectFocus = param.handleSelectFocus, handleSelectBlur = param.handleSelectBlur;
    var ref, ref1;
    var ref2 = (0,useWindowSize/* useWindowSize */.i)(), isMobile = ref2.isMobile, height = ref2.height;
    var modalRouter = (0,useModalRouter/* useModalRouter */.r)();
    var track = (0,useSegment/* useSegment */.K)().track;
    var prodSlug = modalRouter.query.prodSlug;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isAssistant = userCan("MANAGE_USER");
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var order = (0,useOrderState/* useOrderState */.h)().order;
    var cartMenu = (0,useCartMenu/* useCartMenu */.d)();
    var ref3 = (0,react.useState)(false), openDialog = ref3[0], setOpenDialog = ref3[1];
    var ref4 = (0,react.useState)(1), selectedQuantity = ref4[0], setSelectedQuantity = ref4[1];
    var ref5 = (0,react.useState)(false), loading = ref5[0], setLoading = ref5[1];
    var ref6 = (0,useQuery/* useQuery */.a)(getProduct("getFreshProductShow"), {
        variables: {
            params: {
                slug: prodSlug
            }
        },
        returnPartialData: true,
        fetchPolicy: "cache-only"
    }), tmp = ref6.data, ref7 = tmp === void 0 ? {} : tmp, freshProduct = ref7.product;
    var ref8 = (0,useAddProduct/* useAddProduct */.h)({
        location: "product page"
    }), handleAddProduct = ref8.handleAddProduct, addingProduct = ref8.loading;
    var ref9 = (0,useUpdateQuantity/* useUpdateQuantity */.w)({
        product: freshProduct,
        location: "product page"
    }), quantity = ref9.quantity, addQuantity = ref9.addQuantity, MAX_AMOUNT = ref9.MAX_AMOUNT;
    var handleOpenCart = function() {
        cartMenu.open();
        setLoading(false);
    };
    var inCart = order === null || order === void 0 ? void 0 : order.orderDetails.find(function(detail) {
        return detail.product.id === (freshProduct === null || freshProduct === void 0 ? void 0 : freshProduct.id);
    });
    var handleAddButton = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        if (isLocalVendor && (product === null || product === void 0 ? void 0 : (ref = product.availability) === null || ref === void 0 ? void 0 : ref.status) !== "AVAILABLE_24_HRS") return [
                            2
                        ];
                        if (quantity + selectedQuantity > MAX_AMOUNT) {
                            handleOpenCart();
                            return [
                                2
                            ];
                        }
                        if (inCart) {
                            addQuantity(selectedQuantity);
                            setTimeout(function() {
                                cartMenu.open();
                                setLoading(false);
                            }, 1000);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            handleAddProduct({
                                puuid: freshProduct === null || freshProduct === void 0 ? void 0 : freshProduct.uuid,
                                product: freshProduct,
                                quantity: selectedQuantity
                            })
                        ];
                    case 1:
                        _state.sent();
                        cartMenu.open();
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddButton() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCloseModal = (0,react.useCallback)(function() {
        setOpenDialog(false);
    }, []);
    (0,react.useEffect)(function() {
        if (quantity + selectedQuantity > MAX_AMOUNT || !selectedQuantity) {
            setSelectedQuantity(1);
        }
    }, [
        MAX_AMOUNT,
        quantity,
        selectedQuantity
    ]);
    (0,react.useEffect)(function() {
        setSelectedQuantity(1);
    }, [
        product
    ]);
    var isMaxAmount = quantity >= MAX_AMOUNT;
    var helperText = getStockMessage({
        prescriptionType: freshProduct === null || freshProduct === void 0 ? void 0 : freshProduct.prescriptionType,
        quantity: quantity,
        maxAmount: MAX_AMOUNT,
        isMaxAmount: isMaxAmount
    });
    if (!isAssistant && (freshProduct === null || freshProduct === void 0 ? void 0 : freshProduct.prescriptionType) === "CHECK" && !isLocalVendor) return null;
    if ([
        "SOLD_OUT",
        "UNAVAILABLE",
        "HIDDEN"
    ].includes(freshProduct === null || freshProduct === void 0 ? void 0 : (ref = freshProduct.availability) === null || ref === void 0 ? void 0 : ref.status)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddButton, {
                            variant: "contained",
                            onClick: function() {
                                var ref;
                                void track("let me know when available", {
                                    availability: (ref = product.availability) === null || ref === void 0 ? void 0 : ref.status,
                                    brand: product.laboratory,
                                    id: product.id,
                                    name: product.name
                                });
                                setOpenDialog(true);
                            },
                            children: "Av\xedsame cuando est\xe9 disponible"
                        })
                    })
                }),
                openDialog && /*#__PURE__*/ (0,jsx_runtime.jsx)(LetMeKnownWhenItsAvailableModal, {
                    openDialog: openDialog,
                    setClose: handleCloseModal,
                    product: product
                })
            ]
        });
    }
    var optionsLength = Number.isInteger(MAX_AMOUNT - quantity) ? Math.min(20, MAX_AMOUNT - quantity) : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: !isLocalVendor || ((ref1 = freshProduct.availability) === null || ref1 === void 0 ? void 0 : ref1.status) === "AVAILABLE_24_HRS" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnitsContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectContainer, {
                        value: selectedQuantity,
                        onChange: function(event) {
                            return setSelectedQuantity(Number(event.target.value));
                        },
                        displayEmpty: true,
                        open: isSelectOpen,
                        onOpen: handleSelectFocus,
                        onClose: handleSelectBlur,
                        disabled: addingProduct || inCart && isMaxAmount,
                        renderValue: function(selected) {
                            if (inCart && isMaxAmount && !addingProduct) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        quantity,
                                        " ",
                                        pluralize("unidad", quantity, "es"),
                                        " en el carro"
                                    ]
                                });
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "Cantidad: ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityText, {
                                        children: selected
                                    }),
                                    " ",
                                    helperText && /*#__PURE__*/ (0,jsx_runtime.jsxs)(HelperQuantityText, {
                                        children: [
                                            "(",
                                            helperText,
                                            ")"
                                        ]
                                    })
                                ]
                            });
                        },
                        MenuProps: CustomMenu({
                            isMobile: isMobile,
                            height: height
                        }),
                        children: [
                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderModal, {
                                children: [
                                    "Elige cantidad",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: handleSelectBlur,
                                        sx: {
                                            padding: 0
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                    })
                                ]
                            }),
                            optionsLength ? Array.from({
                                length: optionsLength
                            }, function(_, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItemText, {
                                    value: i + 1,
                                    children: [
                                        i + 1,
                                        " ",
                                        pluralize("unidad", i + 1, "es")
                                    ]
                                }, i + 1);
                            }) : null
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AddContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddButton, {
                        variant: "contained",
                        onClick: handleAddButton,
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton, {
                            size: 24
                        }) : isMaxAmount ? "Ir al carro" : "Agregar al carro"
                    })
                })
            ]
        }) : null
    });
};

;// CONCATENATED MODULE: ./src/screens/product/components/Info.styles.ts



var Info_styles_Container = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(768), {
        flexDirection: "row"
    }), (0,_define_property/* default */.Z)(_obj, "width", "100%"), (0,_define_property/* default */.Z)(_obj, "zIndex", 1000), _obj;
});
var InfoRightContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        flexDirection: "column",
        gap: "16px"
    }, theme.breakpoints.up(768), {
        flex: "1 0 50%",
        maxWidth: "50%",
        paddingLeft: "24px"
    });
});
var Info_styles_ContentContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    gap: "8px"
});
var ProductDataContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "column",
        gap: "4px"
    };
});
var OneLineText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
});
var ProductName = (0,styled/* default */.Z)(OneLineText)(function(param) {
    var theme = param.theme;
    return {
        fontSize: "18px",
        fontWeight: 600,
        lineHeight: "32px",
        color: theme.palette.text.primary
    };
});
var ActivePrinciple = (0,styled/* default */.Z)(OneLineText)(function(param) {
    var theme = param.theme;
    return {
        fontSize: "14px",
        fontWeight: 400,
        color: theme.palette.text.secondary
    };
});
var Concentration = (0,styled/* default */.Z)(OneLineText)(function(param) {
    var theme = param.theme;
    return {
        fontSize: "14px",
        fontWeight: 400,
        color: theme.palette.text.secondary
    };
});
var PriceContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        marginTop: "2px",
        color: theme.palette.text.secondary
    };
});
var Price = (0,styled/* default */.Z)(OneLineText)(function(param) {
    var theme = param.theme;
    return {
        fontSize: "22px",
        color: theme.palette.text.primary,
        fontWeight: 600
    };
});
var AveragePrice = (0,styled/* default */.Z)(OneLineText)(function(param) {
    var theme = param.theme;
    return {
        fontSize: "13px",
        color: theme.palette.text.secondary,
        fontWeight: 400
    };
});
var BaseSpan = (0,styled/* default */.Z)("span")({
    display: "block",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    color: "#757575"
});
var LastBuyContainer = (0,styled/* default */.Z)("div")({
    position: "absolute",
    top: 15,
    left: 15,
    borderRadius: "100px",
    border: "0.8px solid #CBCBCB",
    backgroundColor: "#F9F9F9",
    padding: "4px 8px",
    zIndex: 1
});
var LastBuyText = (0,styled/* default */.Z)("span")({
    color: "#414046",
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: "400",
    lineHeight: "19.5px"
});
var LastBuyTextBold = (0,styled/* default */.Z)("span")({
    fontWeight: "600"
});
var DiscountPriceContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    gap: "8px"
});
var PricesContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    gap: "8px"
});
var DiscountPrice = (0,styled/* default */.Z)(BaseSpan)(function() {
    return {
        color: "#5D5FEF",
        fontFamily: "Poppins",
        fontSize: "16px",
        fontWeight: "600",
        lineHeight: "24px",
        letterSpacing: "0.02em"
    };
});
var DiscountChip = (0,styled/* default */.Z)("div")({
    backgroundColor: "#5D5FEF",
    width: "37px",
    height: "18px",
    borderRadius: "100px",
    textAlign: "center",
    gap: "2px",
    position: "relative",
    top: "2px"
});
var DiscountChipTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    color: "#FFFFFF",
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "18px",
    letterSpacing: "-0.01em"
});
var OriginalPrice = (0,styled/* default */.Z)(BaseSpan)({
    color: "#CBCBCB",
    textDecoration: "line-through",
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: "300",
    lineHeight: "24px",
    letterSpacing: "2%"
});
var Overlay = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1200,
        position: "fixed",
        bottom: 0,
        width: "100%",
        left: 0
    }, theme.breakpoints.up("sm"), {
        display: "none"
    });
});

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AcUnit.js
var AcUnit = __webpack_require__(42209);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(30120);
;// CONCATENATED MODULE: ./src/screens/product/components/RefrigeratedInfo.tsx




var RootDiv = (0,styled/* default */.Z)(Box/* default */.Z)({
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "4px 8px",
    backgroundColor: "#2196F31A",
    height: "100%",
    minHeight: "24px"
});
var ImgDiv = (0,styled/* default */.Z)(Box/* default */.Z)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: "#15365F0D",
    width: "24px",
    height: "24px",
    flexShrink: 0
});
var InformationText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.15px",
    color: "#0D3C61",
    flex: 1
});
var RefrigeratedInfo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgDiv, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AcUnit/* default */.Z, {
                    sx: {
                        fontSize: 16,
                        color: "#0D3C61"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationText, {
                children: "Producto refrigerado (2\xb0C - 8\xb0C)"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/screens/product/components/Info.tsx












var currencyFormatter = new CurrencyFormatter/* CurrencyFormatter */.J({
    fallback: ""
});
var extractAveragePriceText = function(product) {
    var ref, ref1;
    var unit = product.unit, regularPrice = product.price, quantity = product.quantity;
    var ref2;
    var price = ((ref = product.discount) === null || ref === void 0 ? void 0 : ref.price) ? (ref2 = (ref1 = product.discount) === null || ref1 === void 0 ? void 0 : ref1.price) !== null && ref2 !== void 0 ? ref2 : regularPrice : regularPrice;
    if (!price) return null;
    if (/comprimido/.exec(unit)) {
        return "Valor comprimido: ".concat(currencyFormatter.format(price / +quantity));
    }
    if (/cápsula/.exec(unit)) {
        return "Valor c\xe1psula: ".concat(currencyFormatter.format(price / +quantity));
    }
    if (/ml/.exec(unit)) {
        return "Valor cada 100 ml: ".concat(currencyFormatter.format(100 * price / +quantity));
    }
    if (/g/.exec(unit)) {
        return "Valor cada 100 g: ".concat(currencyFormatter.format(100 * price / +quantity));
    }
};
var Info = function(param) {
    var product = param.product;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var appUser = (0,useAuth/* useAuth */.a)().appUser;
    var ref16 = (0,react.useState)(false), isSelectOpen = ref16[0], setIsSelectOpen = ref16[1];
    var ref17 = (0,useQuery/* useQuery */.a)(getPillBoxDetail(), {
        variables: {
            params: {
                productSlug: product === null || product === void 0 ? void 0 : product.slug
            }
        },
        skip: !(product === null || product === void 0 ? void 0 : product.slug) || !appUser,
        fetchPolicy: "cache-only"
    }), tmp = ref17.data, pillBoxDetail = (tmp === void 0 ? {} : tmp).pillBoxDetail;
    var handleSelectFocus = function() {
        setIsSelectOpen(true);
    };
    var handleSelectBlur = function() {
        setIsSelectOpen(false);
    };
    var isRefrigerated = product === null || product === void 0 ? void 0 : (ref = product.metadata) === null || ref === void 0 ? void 0 : ref.refrigerated;
    var ref18;
    var originalPrice = ((ref1 = product.discount) === null || ref1 === void 0 ? void 0 : ref1.price) != null ? (ref2 = product.discount) === null || ref2 === void 0 ? void 0 : ref2.listPrice : (ref18 = (ref3 = product.discount) === null || ref3 === void 0 ? void 0 : ref3.price) !== null && ref18 !== void 0 ? ref18 : product.price;
    var discountPercentageRounded = Math.round((originalPrice - ((ref4 = product.discount) === null || ref4 === void 0 ? void 0 : ref4.price)) / originalPrice * 100);
    var ref19;
    // show date as esp: DD/MM/YYYY
    var lastOrderDate = new Date((ref19 = pillBoxDetail === null || pillBoxDetail === void 0 ? void 0 : pillBoxDetail.lastOrderDate) !== null && ref19 !== void 0 ? ref19 : 0).toLocaleString("es", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    });
    var ref20, ref21;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            pillBoxDetail && /*#__PURE__*/ (0,jsx_runtime.jsx)(LastBuyContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LastBuyText, {
                    children: [
                        "Comprado el",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LastBuyTextBold, {
                            children: [
                                " ",
                                lastOrderDate
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info_styles_Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                        product: product
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoRightContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info_styles_ContentContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDataContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductName, {
                                                children: product.name
                                            }),
                                            ((ref5 = product.activePrinciple) === null || ref5 === void 0 ? void 0 : ref5.split(";").length) <= 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivePrinciple, {
                                                children: product.activePrinciple.split(";").slice(0, 3).map(function(text) {
                                                    return text.trim().replace(/\(.*\)/g, "");
                                                }).join(" ; ")
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Concentration, {
                                                children: (0,extractExtraInfo/* extractConcentrationsLabs */.Yh)(product)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Concentration, {
                                                children: (0,extractExtraInfo/* extractUnits */.tT)(product)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceContainer, {
                                                children: [
                                                    ((ref6 = product.discount) === null || ref6 === void 0 ? void 0 : ref6.price) && ![
                                                        "SOLD_OUT",
                                                        "HIDDEN",
                                                        "UNAVAILABLE"
                                                    ].includes((ref7 = product.availability) === null || ref7 === void 0 ? void 0 : ref7.status) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountPriceContainer, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PricesContainer, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountPrice, {
                                                                        children: currencyFormatter.format((ref8 = product.discount) === null || ref8 === void 0 ? void 0 : ref8.price)
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OriginalPrice, {
                                                                        children: currencyFormatter.format((ref20 = (ref9 = product.discount) === null || ref9 === void 0 ? void 0 : ref9.listPrice) !== null && ref20 !== void 0 ? ref20 : product.price)
                                                                    })
                                                                ]
                                                            }),
                                                            discountPercentageRounded >= 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountChip, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountChipTypography, {
                                                                    children: [
                                                                        "-",
                                                                        discountPercentageRounded,
                                                                        "%"
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                                        children: currencyFormatter.format(product.price)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AveragePrice, {
                                                        display: "inline",
                                                        children: extractAveragePriceText(product)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    [
                                        "AVAILABLE",
                                        "REPRESENTATION",
                                        "AVAILABLE_24_HRS"
                                    ].includes((ref10 = product.availability) === null || ref10 === void 0 ? void 0 : ref10.status) && product.prescriptionType !== "CHECK" && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTagDeliveryDate, {
                                        product: product,
                                        maxQuantity: product.availability.stock > 5 || product.prescriptionType === "HELD" ? undefined : Math.max((ref21 = (ref11 = product.discount) === null || ref11 === void 0 ? void 0 : ref11.stock) !== null && ref21 !== void 0 ? ref21 : product.availability.stock, 0)
                                    }),
                                    [
                                        "EXPIRATION",
                                        "MEKI"
                                    ].includes((ref12 = product.discount) === null || ref12 === void 0 ? void 0 : ref12.type) && ![
                                        "SOLD_OUT",
                                        "HIDDEN",
                                        "UNAVAILABLE"
                                    ].includes((ref13 = product.availability) === null || ref13 === void 0 ? void 0 : ref13.status) && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTagDiscountType, {
                                        type: product.discount.type
                                    }),
                                    ((ref14 = product.availability) === null || ref14 === void 0 ? void 0 : ref14.status) == "TO_CONFIRM" && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTagOnDemand, {}),
                                    [
                                        "SOLD_OUT",
                                        "UNAVAILABLE",
                                        "HIDDEN"
                                    ].includes((ref15 = product.availability) === null || ref15 === void 0 ? void 0 : ref15.status) && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTagSoldOut, {}),
                                    product.prescriptionType === "CHECK" && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTagLocalSell, {}),
                                    isRefrigerated && /*#__PURE__*/ (0,jsx_runtime.jsx)(RefrigeratedInfo, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContainer, {
                                product: product,
                                isSelectOpen: isSelectOpen,
                                handleSelectFocus: handleSelectFocus,
                                handleSelectBlur: handleSelectBlur
                            })
                        ]
                    })
                ]
            }),
            isSelectOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {})
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Product/index.tsx + 5 modules
var Product = __webpack_require__(77616);
;// CONCATENATED MODULE: ./src/screens/product/utils/sortedRelatedProducts.ts
var availabilityNumberTransform = {
    AVAILABLE_24_HRS: 0,
    AVAILABLE: 1,
    REPRESENTATION: 2,
    TO_CONFIRM: 3
};
var sortedRelatedProducts = function(relatedProducts, productUUID) {
    var ref;
    return (ref = relatedProducts === null || relatedProducts === void 0 ? void 0 : relatedProducts.filter(function(relatedProduct) {
        var ref;
        return Object.keys(availabilityNumberTransform).includes((ref = relatedProduct.availability) === null || ref === void 0 ? void 0 : ref.status);
    }).filter(function(relatedProduct) {
        return productUUID !== (relatedProduct === null || relatedProduct === void 0 ? void 0 : relatedProduct.uuid);
    }).slice(0, 10)) !== null && ref !== void 0 ? ref : [];
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/format/index.js + 23 modules
var format = __webpack_require__(83877);
// EXTERNAL MODULE: ./src/components/Modal.tsx
var Modal = __webpack_require__(43354);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/HelpRounded.js
var HelpRounded = __webpack_require__(23513);
;// CONCATENATED MODULE: ./src/screens/product/components/PriceComparatorInfoModal.tsx






var QuestionIconButton = (0,styled/* default */.Z)(IconButton/* default */.Z)({
    padding: 1,
    width: "24px",
    height: "24px"
});
function PriceComparatorInfoModal(param) {
    var lastUpdate = param.lastUpdate;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionIconButton, {
                onClick: function() {
                    return setOpen(true);
                },
                size: "large",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpRounded/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* AlertModal */.VF, {
                open: open,
                setOpen: setOpen,
                AlignContentLeft: true,
                title: "Precios online",
                content: "Buscamos los productos en farmaciasahumada.cl, cruzverde.cl, salcobrand.cl y drsimi.cl y te mostramos los precios de lista y los descuentos generales de los que logramos encontrar.\n\nLos descuentos pueden cambiar seg\xfan el d\xeda de la semana, el convenio del cliente y/o el medio de pago.\n\nSi un producto no lo encontramos no significa que no exista en esas farmacias.\n\n".concat(lastUpdate ? "Los precios que mostramos fueron actualizados por \xfaltima vez el ".concat(lastUpdate, ". Pueden haber variado desde entonces.") : ""),
                actions: [
                    {
                        onActionClick: function() {
                            setOpen(false);
                        },
                        text: "Ok"
                    }, 
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Box/Box.js
var Box_Box = __webpack_require__(18377);
// EXTERNAL MODULE: ./src/components/BaseStyles.ts
var BaseStyles = __webpack_require__(8347);
// EXTERNAL MODULE: ./src/components/PageWrapper.tsx
var PageWrapper = __webpack_require__(73362);
;// CONCATENATED MODULE: ./src/screens/product/styles.ts





var ProductPageWrapper = (0,styled/* default */.Z)(PageWrapper/* PageWrapper */.F)({
    backgroundColor: "#f9f9f9",
    padding: "78px 16px !important"
});
var ProductMainCard = (0,styled/* default */.Z)(BaseStyles/* MainCard */.A)(function(param) {
    var padding = param.padding, maxWidth = param.maxWidth, minWidth = param.minWidth;
    return {
        padding: padding,
        maxWidth: maxWidth || "1200px",
        minWidth: minWidth
    };
});
var TopContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    justifyContent: "space-between",
    padding: "12px 24px",
    alignItems: "center"
});
var PriceComparatorTitleContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column"
});
var Title = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    letterSpacing: "0.15px",
    whiteSpace: "nowrap"
});
var DualCardContainer = (0,styled/* default */.Z)(Box_Box/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        gap: "16px",
        flexDirection: "column"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
        flexDirection: "row"
    }), (0,_define_property/* default */.Z)(_obj, "maxWidth", "1200px"), (0,_define_property/* default */.Z)(_obj, "width", "100%"), (0,_define_property/* default */.Z)(_obj, "& > :first-of-type", {
        flex: 1,
        minWidth: "300px"
    }), (0,_define_property/* default */.Z)(_obj, "& > :last-of-type", {
        flex: 2
    }), _obj;
});
var CarouselContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        flex: 1
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
        maxWidth: "1200px"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
        maxWidth: "800px"
    }), _obj;
});

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/WorkspacePremium.js
var WorkspacePremium = __webpack_require__(17437);
;// CONCATENATED MODULE: ./src/screens/product/components/PriceComparator.styles.ts


var Row = (0,styled/* default */.Z)("div")(function(param) {
    var bold = param.bold, firstRanked = param.firstRanked, bottomTextInfo = param.bottomTextInfo;
    return {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        padding: "0 24px",
        minHeight: 48,
        borderTop: "1px solid #eaeaea",
        backgroundColor: firstRanked ? "#A5A6F633" : "white",
        color: firstRanked ? "#5d5fef" : "black",
        fontWeight: bold ? "600" : "none",
        "&:last-child": {
            borderBottomLeftRadius: bottomTextInfo ? "none" : "10px",
            borderBottomRightRadius: bottomTextInfo ? "none" : "10px"
        }
    };
});
var PriceText = (0,styled/* default */.Z)("div")(function(param) {
    var bold = param.bold, discountColor = param.discountColor, firstRanked = param.firstRanked;
    return {
        fontWeight: bold ? "600" : "",
        color: discountColor || firstRanked ? "#5D5FEF" : "black"
    };
});
var ProviderNameDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    fontSize: "16px"
});
var Column = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    fontSize: "16px"
});
var SalePriceText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "12px",
    fontWeight: "400",
    textDecoration: "line-through"
});
var BottomContainer = (0,styled/* default */.Z)("div")({
    padding: "12px 24px",
    borderTop: "1px solid #eaeaea"
});
var BottomTextNoInfo = (0,styled/* default */.Z)(Typography/* default */.Z)({
    textAlign: "left",
    fontSize: "13px",
    color: "#979797"
});
var InfoText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "14px",
    color: "#757475",
    fontWeight: "400",
    lineHeight: "21px"
});


;// CONCATENATED MODULE: ./src/screens/product/components/PriceComparator.tsx











var PharmacyNames;
(function(PharmacyNames) {
    PharmacyNames["farmaciaAhumada"] = "Ahumada";
    PharmacyNames["salcobrand"] = "Salcobrand";
    PharmacyNames["cruzverde"] = "Cruz Verde";
    PharmacyNames["drsimi"] = "Dr. Simi";
    PharmacyNames["meki"] = "Meki";
})(PharmacyNames || (PharmacyNames = {}));
var formatComparatorRows = function(product) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    if (!product) return [];
    var ref6;
    var mekiPrice = ((ref = product.discount) === null || ref === void 0 ? void 0 : ref.price) ? (ref6 = (ref1 = product.discount) === null || ref1 === void 0 ? void 0 : ref1.listPrice) !== null && ref6 !== void 0 ? ref6 : product.price : product.price;
    var ref7, _saleAmount;
    var allProvidersInfo = (0,_to_consumable_array/* default */.Z)(mekiPrice && ![
        "SOLD_OUT",
        "UNAVAILABLE",
        "HIDDEN"
    ].includes((ref2 = product.availability) === null || ref2 === void 0 ? void 0 : ref2.status) ? [
        {
            name: PharmacyNames.meki,
            price: mekiPrice,
            salePrice: (ref3 = product.discount) === null || ref3 === void 0 ? void 0 : ref3.price,
            finalPrice: (ref7 = (ref4 = product.discount) === null || ref4 === void 0 ? void 0 : ref4.price) !== null && ref7 !== void 0 ? ref7 : mekiPrice,
            ranking: -1
        }, 
    ] : []).concat((0,_to_consumable_array/* default */.Z)(product.externalPrices ? (ref5 = product.externalPrices) === null || ref5 === void 0 ? void 0 : ref5.map(function(e) {
        return {
            name: PharmacyNames[e.seller],
            price: e.amount,
            salePrice: e.saleAmount,
            finalPrice: (_saleAmount = e.saleAmount) !== null && _saleAmount !== void 0 ? _saleAmount : e.amount,
            ranking: -1
        };
    }) : []));
    //ordenar por finalPrice
    allProvidersInfo.sort(function(a, b) {
        return (a.finalPrice === null ? 1 : 0) - (b.finalPrice === null ? 1 : 0) || a.finalPrice - b.finalPrice;
    });
    var pricesRanking = Array.from(new Set(allProvidersInfo.map(function(provider) {
        return provider.finalPrice;
    })));
    var allProvidersInfoRanked = allProvidersInfo.map(function(provider, index, providersList) {
        var currentPrice = provider.finalPrice;
        if (index > 0) {
            var previousProvider = providersList[index - 1];
            var previousPrice = previousProvider.finalPrice;
            if (currentPrice === previousPrice) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provider), {
                    ranking: pricesRanking.indexOf(currentPrice) + 1
                });
            }
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provider), {
            ranking: index + 1
        });
    });
    return allProvidersInfoRanked;
};
var PriceComparator_currencyFormatter = new CurrencyFormatter/* CurrencyFormatter */.J();
var PriceComparator = function(param) {
    var product = param.product;
    var ref;
    var rows = formatComparatorRows(product);
    var lastUpdateString = (ref = product.externalPrices) === null || ref === void 0 ? void 0 : ref.reduce(function(min, row) {
        if (!min) return row.lastUpdate;
        return min > row.lastUpdate ? row.lastUpdate : min;
    }, "");
    var lastUpdate = lastUpdateString ? new Date(lastUpdateString) : null;
    var lastUpdateDate = lastUpdate ? (0,format/* default */.Z)(lastUpdate, "dd.MM.yy") : null;
    var lastUpdateTime = lastUpdate ? (0,format/* default */.Z)(lastUpdate, "hh:ii") : null;
    var lastUpdateDateAndTime = lastUpdateDate && lastUpdateTime ? "".concat(lastUpdateDate, " a las ").concat(lastUpdateTime, "hrs") : null;
    var notFoundPrices = Object.values(PharmacyNames).filter(function(value) {
        return !rows.some(function(e) {
            return e.name === value;
        });
    }).join(", ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductMainCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceComparatorTitleContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: "Precios online"
                            }),
                            lastUpdate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoText, {
                                children: [
                                    "Actualizados el ",
                                    lastUpdateDate,
                                    " a las ",
                                    lastUpdateTime,
                                    " hrs."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceComparatorInfoModal, {
                        lastUpdate: lastUpdateDateAndTime
                    })
                ]
            }),
            rows.map(function(row) {
                var firstRanked = row.ranking == 1 && Boolean(row.finalPrice);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                    bold: true,
                    firstRanked: firstRanked,
                    bottomTextInfo: Boolean(notFoundPrices),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProviderNameDiv, {
                            children: [
                                firstRanked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkspacePremium/* default */.Z, {}) : "".concat(row.ranking, "."),
                                " ",
                                row.name
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                            children: [
                                row.salePrice && row.salePrice < row.price && /*#__PURE__*/ (0,jsx_runtime.jsx)(SalePriceText, {
                                    children: PriceComparator_currencyFormatter.format(row.price)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                    bold: row.name === "Meki",
                                    discountColor: row.name === "Meki" && row.salePrice > 0,
                                    firstRanked: firstRanked,
                                    children: row.price || row.salePrice ? PriceComparator_currencyFormatter.format(row.salePrice && row.salePrice < row.price ? row.salePrice : row.price) : "No lo encontramos"
                                })
                            ]
                        })
                    ]
                }, row.name);
            }),
            notFoundPrices && /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomTextNoInfo, {
                    children: [
                        "No se encontraron precios en: ",
                        notFoundPrices
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
;// CONCATENATED MODULE: ./src/screens/product/utils/activePrincipleConcentrationMatch.ts
/*
 * File: activePrincipleConcentrationMatch.ts
 * Project: meki
 * File Created: Friday, 20th January 2023 2:25:42 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 20th January 2023 6:08:58 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2023 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ function activePrincipleConcentrationMatch(product) {
    var joiner = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ", ";
    var ref;
    var activePrinciplesArray = product.activePrinciple.split(";").map(function(e) {
        return e.trim();
    });
    var concentrations = (ref = product.concentration) === null || ref === void 0 ? void 0 : ref.split(";").map(function(e) {
        return e.trim();
    });
    return activePrinciplesArray.map(function(activePrinciple, i) {
        var ref;
        return "".concat(activePrinciple, " ").concat((ref = concentrations === null || concentrations === void 0 ? void 0 : concentrations[i]) !== null && ref !== void 0 ? ref : "").trim();
    }).join(joiner);
}

;// CONCATENATED MODULE: ./src/screens/product/components/DetailCardContent.tsx


function DetailCardContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 12px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    DetailCardContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DetailCardContent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 13px;\n  color: #414046;\n"
    ]);
    DetailCardContent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DetailCardContent_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 13px;\n  color: #979797;\n"
    ]);
    DetailCardContent_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var DetailCardContentSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMainCard, {
        padding: "12px 16px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            variant: "rectangular",
            width: "100%",
            height: 68
        })
    });
};
var DetailCardContent_ContentContainer = (0,styled/* default */.Z)("div")(function(param) {
    var orientation = param.orientation;
    return {
        display: "flex",
        flexDirection: orientation === "horizontal" ? "row" : "column",
        justifyContent: orientation === "horizontal" ? "space-between" : "flex-start",
        padding: orientation === "horizontal" ? "6px 24px 12px" : "12px 24px"
    };
});
var DetailCardContent_Row = (0,styled/* default */.Z)("div")(DetailCardContent_templateObject());
var RowTitle = (0,styled/* default */.Z)(Typography/* default */.Z)(DetailCardContent_templateObject1());
var RowContent = (0,styled/* default */.Z)(Typography/* default */.Z)(DetailCardContent_templateObject2());
var DetailCardContent = function(param) {
    var title = param.title, inputRows = param.rows, _orientation = param.orientation, orientation = _orientation === void 0 ? "vertical" : _orientation, loading = param.loading, description = param.description;
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailCardContentSkeleton, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductMainCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    variant: "h2",
                    children: title
                })
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailCardContent_ContentContainer, {
                orientation: "horizontal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RowContent, {
                    children: description
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailCardContent_ContentContainer, {
                orientation: orientation,
                children: inputRows.map(function(row) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailCardContent_Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowTitle, {
                                children: row.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowContent, {
                                children: row.content
                            })
                        ]
                    }, row.title);
                })
            })
        ]
    });
};
var DescriptionContent = function(param) {
    var product = param.product, _orientation = param.orientation, orientation = _orientation === void 0 ? "vertical" : _orientation, loading = param.loading;
    var ref;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isAssistant = userCan("MANAGE_USER");
    var prescriptionType = product.prescriptionType;
    var ispRegister = (ref = product.metadata) === null || ref === void 0 ? void 0 : ref.ispRegister;
    var activePrinciples = product.activePrinciple;
    var description = product.description;
    var rows = [
        {
            title: "Condici\xf3n de venta:",
            content: prescriptionType ? ({
                HELD: "Receta retenida",
                CHECK: "Receta cheque",
                SIMPLE: "Receta simple" + (isAssistant ? " ✅" : ""),
                NOT_REQUIRED: "Receta simple" + (isAssistant ? " ❌" : "")
            })[prescriptionType] : "Sin receta"
        },
        ispRegister && {
            title: "Registro sanitario:",
            content: ispRegister
        },
        activePrinciples && {
            title: "Principios activos:",
            get content () {
                return "Cada unidad contiene: ".concat(activePrincipleConcentrationMatch(product));
            }
        }, 
    ].filter(Boolean);
    if (!activePrinciples && !ispRegister && !prescriptionType && !description) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailCardContent, {
        title: "Descripci\xf3n",
        rows: rows,
        orientation: orientation,
        loading: loading,
        description: description
    });
};
var SpecificationsContent = function(param) {
    var product = param.product, loading = param.loading;
    if (product.prescriptionType) return null;
    var dict = {
        composition: "Composici\xf3n",
        indications: "Indicaciones",
        posology: "Posolog\xeda",
        contraindications: "Contraindicaciones",
        display: "Presentaci\xf3n"
    };
    var rows = Object.entries(dict).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], title = _param[1];
        var content = product[key];
        if (!content) return;
        return {
            title: title,
            content: content
        };
    }).filter(Boolean);
    if (rows.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailCardContent, {
        title: "Ficha t\xe9cnica",
        rows: rows,
        loading: loading
    });
};
DetailCardContent.Description = DescriptionContent;
DetailCardContent.Specifications = SpecificationsContent;

// EXTERNAL MODULE: ./src/utils/date.ts + 7 modules
var date = __webpack_require__(45974);
;// CONCATENATED MODULE: ./src/queries/pillBox/mutation/updatePillBoxDetail.tsx
/*
 * File: updatePillBoxDetail.tsx
 * Project: meki
 * File Created: Tuesday, 25th January 2022 4:06:36 pm
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Monday, 16th January 2023 3:23:48 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2022 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function updatePillBoxDetail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation updatePillBoxDetail($params: UpdatePillBoxDetailParams!) {\n    updatePillBoxDetail(params: $params) {\n      id\n      lastMovementBalance\n      userStock\n      frequency\n      remainingBalanceDays\n      lastOrderDate\n      speedConsumption\n      consumptionUnit\n      fewPills\n      stillHave\n      allowedFormat\n      hidden\n    }\n  }\n"
    ]);
    updatePillBoxDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var UpdatePillBoxDetailMutation = function() {
    return (0,lib/* gql */.Ps)(updatePillBoxDetail_templateObject());
};

// EXTERNAL MODULE: ./src/hooks/useDebouncedCallback.ts
var useDebouncedCallback = __webpack_require__(93590);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PriorityHigh.js
var PriorityHigh = __webpack_require__(91339);
;// CONCATENATED MODULE: ./src/screens/product/components/PillBox.styles.ts

function PillBox_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PillBox_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var SubTitle = (0,styled/* default */.Z)("div")({
    fontWeight: 500,
    fontSize: 13,
    color: "#757475"
});
var TitleContainer = (0,styled/* default */.Z)(TopContainer)({
    justifyContent: "flex-start",
    gap: 10
});
var InputsContainer = (0,styled/* default */.Z)("form")({
    padding: "12px 15px",
    borderBottom: "1px solid #eaeaea"
});
var InputsTitle = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontWeight: 600,
    fontSize: 13,
    color: "#414046",
    marginBottom: 12
});
var InputsRow = (0,styled/* default */.Z)("div")({
    display: "flex",
    gap: 10
});
var DosageInput = (0,styled/* default */.Z)(TextField/* default */.Z)({
    flex: 1
});
var FrequencyInput = (0,styled/* default */.Z)(TextField/* default */.Z)({
    flex: 1
});
var RemainingContainer = (0,styled/* default */.Z)("div")({
    padding: "12px 15px"
});
var RemainingTitle = (0,styled/* default */.Z)(InputsTitle)(PillBox_styles_templateObject());
var RemainingChipContainer = (0,styled/* default */.Z)("div")(function(param) {
    var type = param.type;
    return {
        display: "flex",
        alignItems: "center",
        background: type === "check" ? "#eef6ed" : "#FFF1C6",
        borderRadius: 23,
        gap: 4,
        padding: "2px 4px",
        width: "fit-content"
    };
});
var RemainingChipIcon = (0,styled/* default */.Z)("div")(function(param) {
    var type = param.type;
    return {
        width: 15,
        height: 15,
        background: type === "check" ? "#00a650" : "#f8d76d",
        borderRadius: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    };
});
var RemainingChipText = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var type = param.type;
    return {
        fontWeight: 500,
        fontSize: 13,
        color: type === "check" ? "#284525" : "#414046"
    };
});
var StyledCheckIcon = (0,styled/* default */.Z)(Check/* default */.Z)({
    color: "white",
    fontSize: 14
});
var StyledPriorityHighIcon = (0,styled/* default */.Z)(PriorityHigh/* default */.Z)({
    color: "white",
    fontSize: 13
});
var InlineSkeleton = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    display: "inline-block"
});

;// CONCATENATED MODULE: ./src/screens/product/components/PillBox.tsx















var PillBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMainCard, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: 40,
                    height: 40
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "rectangular",
                            width: 130,
                            height: 21
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "rectangular",
                            width: 186,
                            height: 21
                        })
                    ]
                })
            ]
        })
    });
};
var icons = {
    check: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheckIcon, {}),
    warning: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPriorityHighIcon, {})
};
var PillBox = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,useAuth/* useAuth */.a)(), appUser = ref3.appUser, authLoading = ref3.loading;
    var track = (0,useSegment/* useSegment */.K)().track;
    var loadedRef = (0,react.useRef)(false);
    var ref4 = (0,useQuery/* useQuery */.a)(getPillBoxDetail(), {
        variables: {
            params: {
                productSlug: (ref = props.product) === null || ref === void 0 ? void 0 : ref.slug
            }
        },
        skip: !((ref1 = props.product) === null || ref1 === void 0 ? void 0 : ref1.slug) || !appUser
    }), tmp = ref4.data, pillBoxDetail = (tmp === void 0 ? {} : tmp).pillBoxDetail, loading = ref4.loading;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UpdatePillBoxDetailMutation()), 2), updatePillBoxDetail = ref5[0], ref6 = ref5[1], updating = ref6.loading;
    var ref7, ref8;
    var ref9 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            frequency: (ref7 = pillBoxDetail === null || pillBoxDetail === void 0 ? void 0 : pillBoxDetail.frequency) !== null && ref7 !== void 0 ? ref7 : 0,
            consumptionUnit: (ref8 = pillBoxDetail === null || pillBoxDetail === void 0 ? void 0 : pillBoxDetail.consumptionUnit) !== null && ref8 !== void 0 ? ref8 : 0
        },
        mode: "onChange"
    }), register = ref9.register, setValue = ref9.setValue, watch = ref9.watch, formState = ref9.formState, reset = ref9.reset;
    register("consumptionUnit");
    register("frequency");
    var values = watch();
    var existPillBoxDetail = Boolean(pillBoxDetail);
    (0,react.useEffect)(function loadInitialPillboxDetailToForm() {
        if (loading || !existPillBoxDetail) return;
        if (loadedRef.current) return;
        loadedRef.current = true;
        reset({
            frequency: pillBoxDetail.frequency,
            consumptionUnit: pillBoxDetail.consumptionUnit
        });
    }, [
        loading,
        pillBoxDetail === null || pillBoxDetail === void 0 ? void 0 : pillBoxDetail.consumptionUnit,
        pillBoxDetail === null || pillBoxDetail === void 0 ? void 0 : pillBoxDetail.frequency,
        existPillBoxDetail,
        reset, 
    ]);
    var update = (0,react.useCallback)(function(data) {
        track("pillbox consumption change");
        return updatePillBoxDetail({
            variables: data
        }).then(function() {
            reset({
                frequency: data.params.frequency,
                consumptionUnit: data.params.consumptionUnit
            });
        });
    }, [
        updatePillBoxDetail,
        reset,
        track
    ]);
    var debouncedUpdate = (0,useDebouncedCallback/* useDebouncedCallback */.y)(update, 300);
    (0,react.useEffect)(function handlePillboxUpdate() {
        var ref;
        if (!formState.isDirty) return;
        void debouncedUpdate({
            params: {
                productSlug: (ref = props.product) === null || ref === void 0 ? void 0 : ref.slug,
                consumptionUnit: values.consumptionUnit,
                frequency: values.frequency
            }
        });
    }, [
        debouncedUpdate,
        (ref2 = props.product) === null || ref2 === void 0 ? void 0 : ref2.slug,
        values.consumptionUnit,
        values.frequency,
        formState.isDirty, 
    ]);
    if (loading || updating || authLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(PillBoxSkeleton, {});
    if (!pillBoxDetail) return null;
    var isSafeUnit = Boolean(/(comprimido|capsula|cápsula)/.exec(props.product.unit));
    var pillBoxTagType = pillBoxDetail.remainingBalanceDays <= 5 ? "warning" : "check";
    var lastOrderDate = new Date(pillBoxDetail.lastOrderDate);
    var daysFromLastPurchase = (0,date/* daysUntil */.dJ)(new Date(Date.now()), lastOrderDate);
    var lastPurchaseText = daysFromLastPurchase > 30 ? "Comprado hace m\xe1s de ".concat(Math.trunc(daysFromLastPurchase / 30), " mes").concat(daysFromLastPurchase >= 60 ? "es" : "") : "\xdaltima compra: ".concat((0,date/* extractMiddleDate */.re)(lastOrderDate));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductMainCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "PillboxLogo",
                        src: "/assets/images/pillbox-logo.webp",
                        width: 40,
                        height: 40
                    }),
                    isSafeUnit ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                variant: "h2",
                                children: "Tu tratamiento"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubTitle, {
                                children: [
                                    "\xdaltima compra: ",
                                    (0,date/* extractMiddleDate */.re)(lastOrderDate)
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                variant: "h2",
                                children: "\xdaltima compra"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                                children: lastPurchaseText
                            })
                        ]
                    })
                ]
            }),
            isSafeUnit && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputsContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputsTitle, {
                                children: "Ingresa tu dosis indicada"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputsRow, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DosageInput, {
                                        label: "Dosis",
                                        select: true,
                                        value: values.consumptionUnit,
                                        onChange: function(e) {
                                            return setValue("consumptionUnit", +e.target.value, {
                                                shouldDirty: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                value: 0.5,
                                                children: "1/2 comprimido"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                value: 1,
                                                children: "1 comprimido"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                value: 1.5,
                                                children: "1 y 1/2 comprimidos"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                value: 2,
                                                children: "2 comprimidos"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                value: 3,
                                                children: "3 comprimidos"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                value: 4,
                                                children: "4 comprimidos"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                value: 5,
                                                children: "5 comprimidos"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FrequencyInput, {
                                        label: "Frecuencia",
                                        select: true,
                                        value: values.frequency,
                                        onChange: function(e) {
                                            return setValue("frequency", +e.target.value, {
                                                shouldDirty: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                value: 1,
                                                children: "al d\xeda"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                value: 7,
                                                children: "a la semana"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RemainingContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RemainingTitle, {
                                children: [
                                    "Te alcanza para",
                                    " ",
                                    updating || loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineSkeleton, {
                                        variant: "rectangular",
                                        width: 30
                                    }) : pillBoxDetail.remainingBalanceDays,
                                    " ",
                                    "d\xedas m\xe1s"
                                ]
                            }),
                            updating || loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: 200
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(RemainingChipContainer, {
                                type: pillBoxTagType,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RemainingChipIcon, {
                                        type: pillBoxTagType,
                                        children: icons[pillBoxTagType]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RemainingChipText, {
                                        type: pillBoxTagType,
                                        children: [
                                            pillBoxDetail.userStock,
                                            " comprimidos restantes",
                                            " "
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./src/screens/product/components/ProductJsonLd.tsx





var obtainJsonLd = function(product) {
    var name = product.name, concentration = product.concentration, thumbnailUrl = product.thumbnailUrl, quantity = product.quantity, format = product.format, activePrinciple = product.activePrinciple, laboratory = product.laboratory, price = product.price, slug = product.slug, prescriptionType = product.prescriptionType, availability = product.availability;
    var ref, ref1;
    return {
        productName: "".concat(name).concat(concentration ? " " + concentration : "").trim().replace(/s+/, " "),
        images: [
            thumbnailUrl
        ],
        description: ((ref = quantity === null || quantity === void 0 ? void 0 : quantity.toString()) !== null && ref !== void 0 ? ref : "") + " " + format + (activePrinciple ? " • ".concat(activePrinciple) : " ") + (laboratory ? " • ".concat(laboratory) : ""),
        brand: laboratory,
        offers: {
            price: [
                "HIDDEN",
                "UNAVAILABLE",
                "SOLD_OUT"
            ].includes(availability === null || availability === void 0 ? void 0 : availability.status) ? null : String(price),
            priceCurrency: "CLP",
            seller: {
                name: "Meki"
            },
            url: "".concat(environment/* BASE_URL */._n, "/producto/").concat(slug),
            availability: "https://schema.org/".concat(prescriptionType !== "CHECK" ? (ref1 = utils/* availabilityToSchema */.t1[availability === null || availability === void 0 ? void 0 : availability.status]) !== null && ref1 !== void 0 ? ref1 : "LimitedAvailability" : "InStoreOnly")
        }
    };
};
var ProductJsonLd = function(props) {
    var product = props.product;
    if (!product) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* ProductJsonLd */.Qb, (0,_object_spread/* default */.Z)({}, obtainJsonLd(product)));
};

// EXTERNAL MODULE: ./src/screens/home/landing/ReferralBannerDiscountSection/referralBannerDiscount.tsx + 1 modules
var referralBannerDiscount = __webpack_require__(30396);
// EXTERNAL MODULE: ./src/hooks/useMekiState.tsx + 1 modules
var useMekiState = __webpack_require__(48231);
// EXTERNAL MODULE: ./src/queries/referenceCoupon/queries/validateReferenceCoupon.ts
var validateReferenceCoupon = __webpack_require__(94626);
// EXTERNAL MODULE: ./src/hooks/useModalOpenState.tsx
var useModalOpenState = __webpack_require__(57117);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx
var Header = __webpack_require__(23722);
// EXTERNAL MODULE: ./src/queries/products/queries/index.tsx + 5 modules
var queries = __webpack_require__(72861);
;// CONCATENATED MODULE: ./src/screens/product/index.tsx

























var DualCardContainerSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DualCardContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMainCard, {
                padding: "12px 16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: "100%",
                    height: 252
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMainCard, {
                padding: "12px 16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: "100%",
                    height: 252
                })
            })
        ]
    });
};
function ProductPage(props) {
    var ref;
    var router = (0,next_router.useRouter)();
    var _query = router.query, code = _query.codigo, prodSlug = _query.prodSlug, location = _query.location;
    var track = (0,useSegment/* useSegment */.K)().track;
    var ref1 = (0,useAuth/* useAuth */.a)(), user = ref1.appUser;
    var closeModal = (0,useModalOpenState/* useOpenModal */.R)().closeModal;
    var setReferralCode = (0,useMekiState/* useMekiState */.c)().setReferralCode;
    var ref2 = (0,react.useState)(true), isBannerVisible = ref2[0], setIsBannerVisible = ref2[1];
    var ref3 = (0,useQuery/* useQuery */.a)(getProduct("getFreshProductShow"), {
        variables: {
            params: {
                slug: prodSlug
            }
        },
        skip: !prodSlug,
        returnPartialData: true
    }), tmp = ref3.data, ref4 = tmp === void 0 ? {} : tmp, freshProduct = ref4.product, freshProductLoading = ref3.loading;
    var ref5 = (0,useQuery/* useQuery */.a)((0,queries/* ProductQuery */.s)("SearchResults"), {
        variables: {
            params: {
                query: freshProduct === null || freshProduct === void 0 ? void 0 : freshProduct.name,
                pageNumber: 1
            }
        },
        fetchPolicy: "cache-first",
        skip: freshProduct === null || freshProduct === void 0 ? void 0 : freshProduct.isMedicine
    }), nonMedicineRelatedProductsData = ref5.data, nonMedicineRelatedProductsLoading = ref5.loading;
    var loading = freshProductLoading || nonMedicineRelatedProductsLoading;
    var codeString = code ? decodeURI(code) : "";
    var ref6 = (0,useQuery/* useQuery */.a)((0,validateReferenceCoupon/* ValidateReferenceCouponQuerie */.j)(), {
        variables: {
            params: {
                code: codeString.replace(/\s.*/g, "")
            }
        },
        fetchPolicy: "cache-first",
        skip: !codeString.replace(/\s.*/g, "")
    }), tmp1 = ref6.data, ref7 = tmp1 === void 0 ? {} : tmp1, referralUser = ref7.validateReferenceCoupon;
    var product = freshProduct || props.initialProduct;
    var relatedProducts = (product === null || product === void 0 ? void 0 : product.isMedicine) ? sortedRelatedProducts(product === null || product === void 0 ? void 0 : product.relatedProducts, product === null || product === void 0 ? void 0 : product.uuid) : sortedRelatedProducts(nonMedicineRelatedProductsData === null || nonMedicineRelatedProductsData === void 0 ? void 0 : nonMedicineRelatedProductsData.products.nodes, product === null || product === void 0 ? void 0 : product.uuid);
    (0,react.useEffect)(function() {
        if (code && (referralUser === null || referralUser === void 0 ? void 0 : referralUser.isValid)) {
            setReferralCode(referralUser.code);
        }
    }, [
        code,
        referralUser,
        setReferralCode
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (loading) return;
        var ref1, ref2, ref3;
        void track("product view", {
            id: product === null || product === void 0 ? void 0 : product.id,
            name: product === null || product === void 0 ? void 0 : product.name,
            availability: product === null || product === void 0 ? void 0 : (ref = product.availability) === null || ref === void 0 ? void 0 : ref.status,
            brand: (ref1 = product === null || product === void 0 ? void 0 : product.makerBrand) !== null && ref1 !== void 0 ? ref1 : product === null || product === void 0 ? void 0 : product.laboratory,
            price: (ref2 = product === null || product === void 0 ? void 0 : product.price) !== null && ref2 !== void 0 ? ref2 : "null",
            prescriptionType: (ref3 = product === null || product === void 0 ? void 0 : product.prescriptionType) !== null && ref3 !== void 0 ? ref3 : "null",
            location: location
        });
    }, [
        track,
        product === null || product === void 0 ? void 0 : product.id,
        product === null || product === void 0 ? void 0 : product.laboratory,
        product === null || product === void 0 ? void 0 : product.availability,
        product === null || product === void 0 ? void 0 : product.name,
        product === null || product === void 0 ? void 0 : product.price,
        product === null || product === void 0 ? void 0 : product.prescriptionType,
        loading,
        product === null || product === void 0 ? void 0 : product.makerBrand,
        location, 
    ]);
    var isDesktop = (0,useWindowSize/* useWindowSize */.i)().isDesktop;
    var cartMenu = (0,useCartMenu/* useCartMenu */.d)();
    var isCartOpen = cartMenu.isOpen;
    (0,react.useEffect)(function() {
        if (isCartOpen && isDesktop) {
            closeModal();
        }
    }, [
        isCartOpen,
        isDesktop,
        closeModal
    ]);
    var hasRelatedProducts = (relatedProducts === null || relatedProducts === void 0 ? void 0 : relatedProducts.length) > 0;
    var title = (product === null || product === void 0 ? void 0 : product.isMedicine) ? ((ref = product.activePrinciple) === null || ref === void 0 ? void 0 : ref.split(";").length) === 1 ? "Otros: ".concat(product === null || product === void 0 ? void 0 : product.activePrinciple, " ").concat(product === null || product === void 0 ? void 0 : product.concentration) : "Otras alternativas: ".concat(product === null || product === void 0 ? void 0 : product.activePrinciple, " ") : "Te podr\xeda interesar";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWrapper/* BackgroundGlobalStyle */.m, {
                mobileColor: "gray"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                hasSearchBox: true
            }),
            product && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductMainCard, {
                        padding: "24px",
                        children: [
                            !user && (referralUser === null || referralUser === void 0 ? void 0 : referralUser.isValid) && /*#__PURE__*/ (0,jsx_runtime.jsx)(referralBannerDiscount/* ReferralBannerDiscount */.N, {
                                referenceCouponValidation: referralUser,
                                isBannerVisible: isBannerVisible,
                                setIsBannerVisible: setIsBannerVisible
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductJsonLd, {
                                product: product
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {
                                product: product
                            })
                        ]
                    }),
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DualCardContainerSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(DualCardContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceComparator, {
                                product: product
                            }),
                            hasRelatedProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Product/* Products.Carousel */.Q.Carousel, {
                                    data: relatedProducts.map(function(product) {
                                        return {
                                            product: product
                                        };
                                    }),
                                    loading: loading,
                                    title: title,
                                    location: "related products"
                                })
                            }),
                            !hasRelatedProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailCardContent.Description, {
                                product: product
                            })
                        ]
                    }),
                    hasRelatedProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailCardContent.Description, {
                        orientation: isDesktop ? "horizontal" : "vertical",
                        product: product,
                        loading: loading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PillBox, {
                        product: product
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailCardContent.Specifications, {
                        product: product,
                        loading: loading
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/producto/[prodSlug]/index.tsx










var __N_SSP = true;
function ShowProduct(param) {
    var product = param.initialProduct;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var apolloClient = (0,useApolloClient/* useApolloClient */.x)();
    (0,react.useEffect)(function redirectToBaseWithModal() {
        if (!(product === null || product === void 0 ? void 0 : product.slug)) return;
        apolloClient.writeQuery({
            query: getProduct("getProductInShowDeailtStaticProps"),
            variables: {
                params: {
                    slug: product.slug
                }
            },
            data: {
                product: product
            }
        });
    }, [
        router,
        product === null || product === void 0 ? void 0 : product.slug,
        product,
        apolloClient
    ]);
    var currFormat = new CurrencyFormatter/* CurrencyFormatter */.J({
        fallback: environment/* NEXT_PUBLIC_NO_PRICE_FALLBACK */.uh
    });
    utils/* Console.log */.Mn.log({
        msg: "[FLICKER] prodSlug",
        product: product
    });
    (0,react.useEffect)(function redirectNoProductFound() {
        if (!product) {
            void router.push({
                pathname: "/404"
            });
        }
    }, [
        product,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* SEOHead */.R, {
                title: product ? "".concat(product.name).concat(product.concentration ? " " + product.concentration : "").concat((product === null || product === void 0 ? void 0 : (ref = product.discount) === null || ref === void 0 ? void 0 : ref.price) ? " • ".concat(currFormat.format(product === null || product === void 0 ? void 0 : (ref1 = product.discount) === null || ref1 === void 0 ? void 0 : ref1.price)) : product.price ? " • ".concat(currFormat.format(product.price)) : "") : "Meki • Productos",
                canonical: "".concat(environment/* BASE_URL */._n, "/producto/").concat(product === null || product === void 0 ? void 0 : product.slug),
                description: product ? product.quantity.toString() + " " + product.format + (product.activePrinciple ? " • ".concat(product.activePrinciple) : " ") + (product.laboratory ? " • ".concat(product.laboratory) : "") : "",
                customImage: {
                    url: product === null || product === void 0 ? void 0 : product.thumbnailUrl,
                    type: "image/png",
                    width: "256",
                    height: "256"
                }
            }),
            product && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage, {})
        ]
    });
}


/***/ }),

/***/ 43354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cv": function() { return /* binding */ ErrorModal; },
/* harmony export */   "VF": function() { return /* binding */ AlertModal; }
/* harmony export */ });
/* unused harmony export ModalDialogContentText */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26993);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1890);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68346);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13264);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60031);
/*
 * File: Modal.tsx
 * Project: @inventures/react-lib
 * File Created: Wednesday, 23rd September 2020 4:10:47 pm
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Wednesday, 12th July 2023 6:57:54 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2020 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 










var IconContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({
    position: "relative",
    height: "14px",
    width: "14px",
    marginLeft: "90%",
    marginTop: "20px"
});
var Container = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({});
var DialogTitle = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "17px",
    lineHeight: "150%",
    letterSpacing: "0.15px",
    color: "#414046",
    textAlign: "center",
    marginBottom: "12px"
});
var DialogContentText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "150%",
    letterSpacing: "-0.011em",
    textAlign: "center",
    color: "#414046",
    margin: "0px 18px 12px 18px"
});
var DialogActions = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "direction";
    }
})(function(param) {
    var direction = param.direction;
    return {
        display: "flex",
        flexDirection: direction || "column",
        alignItems: "center",
        padding: direction === "row" ? "16px" : "17px 0px",
        gap: direction === "row" ? "16px" : "0px"
    };
});
var ButtonAction = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    borderRadius: "100px",
    height: "42px",
    width: "199px",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    textDecoration: "none",
    textTransform: "none"
});
var Pointer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({
    cursor: "pointer"
});
var ModalDialog = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "changeDialogPaper";
    }
})(function(param) {
    var changeDialogPaper = param.changeDialogPaper;
    return {
        "& .MuiDialog-paper": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            margin: 16,
            maxWidth: 336
        }, changeDialogPaper ? {
            width: "100%",
            minHeight: 197
        } : {})
    };
});
var ModalDialogContentText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(DialogContentText, {
    shouldForwardProp: function(prop) {
        return prop !== "alingContentLeft";
    }
})(function(param) {
    var alignContentLeft = param.alignContentLeft;
    return {
        textAlign: alignContentLeft ? "left" : "center",
        whiteSpace: "pre-line"
    };
});
function AlertModal(props) {
    var title = props.title, open = props.open, content = props.content, children = props.children, actions = props.actions, actionsDirection = props.actionsDirection, setOpen = props.setOpen, onClose = props.onClose, disableEscapeKeyDown = props.disableEscapeKeyDown, onBackdropClick = props.onBackdropClick, AlignContentLeft = props.AlignContentLeft, changeDialogPaper = props.changeDialogPaper, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(props, [
        "title",
        "open",
        "content",
        "children",
        "actions",
        "actionsDirection",
        "setOpen",
        "onClose",
        "disableEscapeKeyDown",
        "onBackdropClick",
        "AlignContentLeft",
        "changeDialogPaper"
    ]);
    var handleClose = function() {
        if (onClose) onClose();
        else if (actions.length === 1) actions[0].onActionClick();
        setOpen(false);
    };
    var haveHandleClose = (actions === null || actions === void 0 ? void 0 : actions.length) === 1 || onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalDialog, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, otherProps), {
        open: open,
        onClose: handleClose,
        changeDialogPaper: changeDialogPaper,
        disableEscapeKeyDown: disableEscapeKeyDown,
        onBackdropClick: onBackdropClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconContainer, {
                    children: haveHandleClose && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Pointer, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            layout: "fill",
                            src: "/assets/images/home/closeicon.webp",
                            alt: "closeIcon",
                            objectFit: "contain",
                            onClick: handleClose
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogTitle, {
                    children: title
                }),
                content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalDialogContentText, {
                    alignContentLeft: AlignContentLeft,
                    children: content
                }),
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogActions, {
                    direction: actionsDirection,
                    children: actions === null || actions === void 0 ? void 0 : actions.map(function(action, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonAction, {
                            onClick: action.onActionClick,
                            color: "primary",
                            variant: action.variant,
                            children: action.text
                        }, index);
                    })
                })
            ]
        })
    }));
}
function ErrorModal(props) {
    var open = props.open, title = props.title, description = props.description, handleBack = props.handleBack, whatsappText = props.whatsappText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AlertModal, {
        title: title,
        open: open,
        setOpen: function() {},
        disableEscapeKeyDown: true,
        disableBackdropClick: true,
        actions: [
            {
                text: "Aceptar",
                onActionClick: handleBack,
                variant: "contained"
            }, 
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ModalDialogContentText, {
            children: [
                description,
                ", intenta nuevamente o",
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    target: "_blank",
                    href: "https://api.whatsapp.com/send?phone=".concat(_config_environment__WEBPACK_IMPORTED_MODULE_3__/* .PHONE_NUMBER.CLEAN */ .UE.CLEAN, "&text=").concat(encodeURI(whatsappText)),
                    children: "cont\xe1ctanos para recibir ayuda"
                })
            ]
        })
    });
}


/***/ }),

/***/ 24714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ModalImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13264);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73224);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80562);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50594);
/* harmony import */ var _mui_icons_material_Download__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63441);







var Modal = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
var ImageModalContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div")({
    position: "relative"
});
var ImageModal = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("img", {
    shouldForwardProp: function(prop) {
        return prop !== "isProduct";
    }
})(function(param) {
    var isProduct = param.isProduct;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, isProduct ? {
        maxWidth: "90dvw",
        maxHeight: "90dvh"
    } : {
        maxWidth: "75dvw",
        maxHeight: "90dvh"
    });
});
var PdfImage = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("object")({
    width: "75vw",
    height: "90dvh",
    objectFit: "cover"
});
var DeleteIconButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    backgroundColor: "rgb(50, 49, 54)",
    color: "white",
    height: "35px",
    width: "35px",
    position: "absolute",
    top: "8px",
    right: "8px"
});
var CloseIconSized = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    fontSize: "25px"
});
var DownloadIconButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    backgroundColor: "rgb(50, 49, 54)",
    color: "white",
    height: "35px",
    width: "35px",
    position: "absolute",
    bottom: "8px",
    right: "8px",
    cursor: "pointer",
    borderRadius: "50%"
});
var DownloadIconSized = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_icons_material_Download__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    fontSize: "25px"
});
function ModalImage(props) {
    var imageModal = props.imageModal, setImageModal = props.setImageModal, imageUrl = props.imageUrl, handleImageError = props.handleImageError, productName = props.productName, isProduct = props.isProduct;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Modal, {
            open: imageModal,
            onClose: function() {
                return setImageModal(false);
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ImageModalContainer, {
                children: [
                    !(imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.includes(".pdf")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageModal, {
                                src: imageUrl,
                                alt: "Foto ".concat(productName),
                                onError: handleImageError,
                                isProduct: isProduct
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DeleteIconButton, {
                                onClick: function() {
                                    return setImageModal(false);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloseIconSized, {})
                            }),
                            !isProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DownloadIconButton, {
                                onClick: function() {
                                    return window.open(imageUrl, "_blank");
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DownloadIconSized, {})
                            })
                        ]
                    }),
                    (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.includes(".pdf")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PdfImage, {
                            data: imageUrl,
                            type: "application/pdf",
                            title: "Contenedor"
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 39425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ SEOHead; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var _siteMetaData_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64507);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60031);










var BASE_IMAGES = [
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/Meki.jpg",
        type: "image/jpg",
        width: 1200,
        height: 630
    },
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/1200x630.png",
        type: "image/png",
        width: 1200,
        height: 630
    },
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/256x256.jpg",
        type: "image/jpg",
        width: 256,
        height: 256
    },
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/256x256.png",
        type: "image/png",
        width: 256,
        height: 256
    }, 
];
function SEOHead(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var description = props.description, title = props.title, customImage = props.customImage, canonical = props.canonical;
    var site = _siteMetaData_json__WEBPACK_IMPORTED_MODULE_4__/* .landing */ ._;
    var image = customImage;
    var metaDescription = description ? description : site.description;
    var metaTitle = title || site.title;
    var headData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        title: metaTitle,
        description: metaDescription
    }, canonical ? {
        canonical: canonical
    } : {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, headData), {
                openGraph: {
                    title: metaTitle,
                    description: metaDescription,
                    type: site.type,
                    url: "".concat(_config_environment__WEBPACK_IMPORTED_MODULE_6__/* .BASE_URL */ ._n).concat(router.asPath),
                    images: [
                        image && {
                            url: image.url,
                            width: Number(image.width.replace("px", "")),
                            height: Number(image.height.replace("px", "")),
                            alt: metaTitle
                        }, 
                    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(BASE_IMAGES)).filter(Boolean)
                },
                additionalMetaTags: [
                    {
                        name: "viewport",
                        content: site.scale
                    }
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    charSet: site.charSet
                })
            })
        ]
    });
}


/***/ }),

/***/ 30396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ ReferralBannerDiscount; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/screens/home/landing/ReferralBannerDiscountSection/referralBannerDiscount.styles.ts
/*
 * File: referralBannerDiscount.styles.tsx
 * Project: meki
 * File Created: Wednesday, 3rd May 2023 8:43:19 pm
 * Author: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Last Modified: Wednesday, 3rd May 2023 9:33:10 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2023 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 


var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#B9D4FF",
    position: "sticky",
    bottom: 0,
    left: 0,
    width: "100%",
    minHeight: "58px",
    maxHeight: "66px",
    zIndex: 500
});
var GiftAmountTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        fontFamily: "Poppins",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "150%"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(700), {
        fontSize: "18px"
    }), (0,_define_property/* default */.Z)(_obj, "letterSpacing", "-0.011em"), (0,_define_property/* default */.Z)(_obj, "color", "#15365F"), _obj;
});
var ValidityTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        fontFamily: "Poppins",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "150%"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(700), {
        fontSize: "12px"
    }), (0,_define_property/* default */.Z)(_obj, "letterSpacing", "-0.011em"), (0,_define_property/* default */.Z)(_obj, "color", "#15365F"), _obj;
});
var CloseIconButton = (0,styled/* default */.Z)(IconButton/* default */.Z)(function() {
    return {
        position: "absolute",
        top: "5px",
        right: "5px"
    };
});


// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Clear.js
var Clear = __webpack_require__(63343);
;// CONCATENATED MODULE: ./src/screens/home/landing/ReferralBannerDiscountSection/referralBannerDiscount.tsx





function ReferralBannerDiscount(props) {
    var ref;
    var ref1 = (ref = props === null || props === void 0 ? void 0 : props.referenceCouponValidation) !== null && ref !== void 0 ? ref : {}, name = ref1.name, _lastName = ref1.lastName, lastName = _lastName === void 0 ? "" : _lastName, code = ref1.code, amount = ref1.amount, type = ref1.type, deliveryPeriods = ref1.deliveryPeriods, deliveryQuantity = ref1.deliveryQuantity;
    var setIsBannerVisible = props.setIsBannerVisible, isBannerVisible = props.isBannerVisible;
    if (!isBannerVisible) return null;
    if (type === "DELIVERY_COUPON" && deliveryPeriods === 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GiftAmountTypography, {
                    children: [
                        "Tienes ",
                        deliveryQuantity,
                        " despacho",
                        deliveryQuantity > 1 ? "s" : "",
                        " ",
                        "gratis, sin m\xednimo de compra"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ValidityTypography, {
                    children: "V\xe1lido para clientes nuevos"
                })
            ]
        });
    }
    if (type === "DELIVERY_COUPON" && deliveryPeriods > 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GiftAmountTypography, {
                    children: [
                        deliveryQuantity,
                        " despacho",
                        deliveryQuantity > 1 ? "s" : "",
                        " gratis al mes, sin m\xednimo de compra"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValidityTypography, {
                    children: [
                        "V\xe1lido para clientes nuevos durante ",
                        deliveryPeriods,
                        " meses"
                    ]
                })
            ]
        });
    }
    var message = "\xa1".concat((0,utils/* capitalizeWord */.ZX)(name !== null && name !== void 0 ? name : code)).concat(lastName ? " ".concat(lastName.charAt(0).toUpperCase(), ".") : "", " te regal\xf3 ").concat(amount === null || amount === void 0 ? void 0 : amount.toLocaleString("es-CL", {
        style: "currency",
        currency: "CLP"
    }), " de descuento!");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconButton, {
                onClick: function() {
                    return setIsBannerVisible(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clear/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftAmountTypography, {
                children: message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValidityTypography, {
                children: "V\xe1lido para clientes nuevos"
            })
        ]
    });
}


/***/ }),

/***/ 64507:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"_":{"title":"Meki · Farmacia a domicilio","description":"Todo lo que necesitas, hasta los medicamentos difíciles. Precios bajos y convenio con Cenabast. Despacho GRATIS en Santiago por compras sobre $35.000.","author":"@mimeki","type":"website","charSet":"utf-8","scale":"width=device-width, initial-scale=1","image":{"url":"https://meki-public.s3.us-east-2.amazonaws.com/meta/Meki.jpg","type":"image/jpg","width":"1200","height":"630"},"imageCart":{"url":"https://meki-public.s3.us-east-2.amazonaws.com/meta/metadataCarrito.png","type":"image/png","width":"256","height":"256"}}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,7536,9774,2888,179], function() { return __webpack_exec__(54961), __webpack_exec__(98529); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);